import { useContext } from 'react';
import { SquadContext, type SquadContextValue } from './SquadProvider.tsx';

export function useSquad(): SquadContextValue {
  const ctx = useContext(SquadContext);
  if (!ctx) throw new Error('useSquad must be used within a SquadProvider');
  return ctx;
}
